/*
 * Whether a module is in the list /api/modules returned.
 *
 * Takes the whole react-query object, not the array, exactly as isFeatureEnabled does — call
 * sites pass `modulesQuery`, and MachineDetails threads it to a child as a prop.
 *
 * Returns false while the query is in flight and false if it fails, because `data` is undefined
 * in both cases. That is the fail-safe the CMMS gate depends on: an installation that cannot
 * answer the question does not get the module.
 *
 * It lives in its own file rather than beside the hook so it can be tested. useModules imports
 * the fetcher, the fetcher imports axios, and axios ships ESM that CRA 5's Jest does not
 * transform — importing the hook from a test fails to compile, exactly as App.test.js does.
 * Call sites should keep importing it from useModules, which re-exports it.
 */
export const isModuleEnabled = (modules, moduleId) => {
    return modules?.data?.enabledModules?.some(m => m.id === moduleId) === true;
};

export default isModuleEnabled;
